import React from "react";

// types
import { ButtonProps } from "./Button.types";

// css
import "./style.css";
const defaultProps: ButtonProps = {
  buttonLabel: "",
  varient: "",
  disabled: false,
  size: "",
  type: "button",
  handleClick: () => {},
  className: "",
};

const index = (props: ButtonProps) => {
  const {
    varient,
    buttonLabel,
    size,
    handleClick,
    disabled,
    className,
    type,
    ...rest
  } = props;

  return (
    <button
      type={type}
      className={`${varient} ${size} ${className} ${
        disabled ? "disabled" : ""
      }`}
      onClick={handleClick}
      disabled={disabled}
      {...rest}
    >
      {buttonLabel}
    </button>
  );
};

export default index;

index.defaultProps = defaultProps;
